export const dataContent = [
  {
    no: 1,
    projectName: "MONITORING PENYALURAN BLT BBM TAHAP 1",
    step: "Planing",
    location: "Jakarta",
    member: "1000",
    task: "10",
    progress: "70%",
    dateCreated: "24 Sep 2022",
  },
  {
    no: 2,
    projectName: "MONITORING PENYALURAN BLT BBM TAHAP 1",
    step: "Planing",
    location: "Jakarta",
    member: "1000",
    task: "10",
    progress: "70%",
    dateCreated: "24 Sep 2022",
  },
  {
    no: 3,
    projectName: "MONITORING PENYALURAN BLT BBM TAHAP 1",
    step: "Planing",
    location: "Jakarta",
    member: "1000",
    task: "10",
    progress: "70%",
    dateCreated: "24 Sep 2022",
  },
  {
    no: 4,
    projectName: "MONITORING PENYALURAN BLT BBM TAHAP 1",
    step: "Planing",
    location: "Jakarta",
    member: "1000",
    task: "10",
    progress: "70%",
    dateCreated: "24 Sep 2022",
  },
  {
    no: 5,
    projectName: "MONITORING PENYALURAN BLT BBM TAHAP 1",
    step: "Planing",
    location: "Jakarta",
    member: "1000",
    task: "10",
    progress: "70%",
    dateCreated: "24 Sep 2022",
  },
];

export const dataTask = [
  {
    no: 1,
    title: "Membuat halaman utama grup",
    description: "Membuat halaman utama grup",
    officer: "Muh Arifandi",
    status: "Sudah Dikerjakan",
  },
  {
    no: 2,
    title: "Membuat halaman utama grup",
    description: "Membuat halaman utama grup",
    officer: "Muh Arifandi",
    status: "Sedang Berjalan",
  },
  {
    no: 3,
    title: "Membuat halaman utama grup",
    description: "Membuat halaman utama grup",
    officer: "Muh Arifandi",
    status: "Selesai",
  },
];

export const notification = [
  {
    name: "Muh. Arifandi",
    text: "Menyelesaikan Task membuat UI",
  },
  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },
  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },
  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },
  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },
  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },
  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },

  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },
  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },
  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },
  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },

  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },
  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },
  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },
  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },

  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },
  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },
  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },
  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },

  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },
  {
    name: "Muh. Arifandi",
    text: "telah memposting sesuatu di social media.",
  },
];
